import {
    CLEAR_DEVICE_ERRORS,
    CREATE_NEW_DEVICE_DATA,
    DELETE_DEVICE_DATA,
    EDIT_DEVICE_DATA,
    REINITIATE_DEVICE,
    KNOWN_DEVICES_FETCH_DATA,
    SAVE_DEVICES_TO_STORE,
    SUBMIT_DEVICE_DATA
} from "../../constant/reducerConstants";
import {get, post} from "./apiActions";
import db from '../persistence/db';
import {STORE_NAMES} from "../persistence/dbClient";
import {DEVICE_STATUS} from "../../util/DeviceUtils";
import {infoAlertPush} from './alertActions';
import {AppInfo} from '../../constant/appAlerts';

const DEVICE_PATH = '/v1.0/device/';

export const DEFAULT_MAC = "24dbad______";

const getNewId = function () {
    return 'new-' + new Date().getTime();
};

export const knownDevicesFetchData = () => {
    const options = {
        path: DEVICE_PATH,
        requestName: KNOWN_DEVICES_FETCH_DATA
    };
    return get(options);
};

export const submitDevices = (devices) => {
    devices.map(device => delete device.metadata.errorMap);
    const options = {
        body: devices,
        path: DEVICE_PATH,
        requestName: SUBMIT_DEVICE_DATA,
        successCode: 207,
        successCallback: submitDevicesCallback
    };
    return post(options);
};

const submitDevicesCallback = (data) => (dispatch) => {
    dispatch(infoAlertPush(AppInfo.SUBMIT_COMPLETE));
    dispatch({
        type: SUBMIT_DEVICE_DATA,
        data
    });
    dispatch(knownDevicesFetchData());
};

export const devicesAddNew = (siteId) => {
    let device = {
        equipDetailsId: getNewId(),
        siteId: siteId,
        metadata: {
            status: DEVICE_STATUS.new,
            edits: {
                mac: DEFAULT_MAC
            }
        }
    };
    db.putDevice(device, STORE_NAMES.DEVICES_STORE);
    return {
        type: CREATE_NEW_DEVICE_DATA,
        device
    };
};

export const devicesDeleteData = id => {
    db.deleteDevice(id, STORE_NAMES.DEVICES_STORE);
    return {
        type: DELETE_DEVICE_DATA,
        id
    };
};

export const devicesSaveEdit = (id) => (edits) => {
    let callback = (device) => {
        db.putDevice(device);
    };
    return {
        type: EDIT_DEVICE_DATA,
        id,
        edits,
        callback
    };
};

export const devicesClearErrors = (id) => {
    return {
        type: CLEAR_DEVICE_ERRORS,
        id
    };
};

export const triggerGetDevicesFromDb = (siteId) => (dispatch) => {
    db.getAllDevices(siteId, saveDevicesToStore(dispatch));
};

const saveDevicesToStore = (dispatch) => ({devices}) => {
    dispatch({
        type: SAVE_DEVICES_TO_STORE,
        devices
    });
};

export const reinitiateDevice = (devices) => {
    const options = {
        body: devices,
        path: DEVICE_PATH + "reinitiate",
        requestName: REINITIATE_DEVICE,
        successCode: 207,
        successCallback: reinitiateDeviceCallback
    };
    return post(options);
};

const reinitiateDeviceCallback = (data) => (dispatch) => {
    dispatch({
        type: REINITIATE_DEVICE,
        data
    });
    dispatch(knownDevicesFetchData());
};


// WEBPACK FOOTER //
// ./src/state/action/deviceActions.js